import { DIM2CLASS } from '../core/icon-class';

class FilterDimensionController {
  constructor(
    $scope,
    CurrentFilterService,
    AggregateDataService,
    CurrentModelService,
    $rootScope,
    ErrorHandlerService,
    RouterService,
    CurrentFilterDataService,
  ) {
    this.$scope = $scope;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.DIM2CLASS = DIM2CLASS;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.$rootScope = $rootScope;
    this.ErrorHandlerService = ErrorHandlerService;
    this.RouterService = RouterService;
    this.AggregateDataService = AggregateDataService;
    this.CurrentFilterDataService = CurrentFilterDataService;
  }

  get panel() {
    return this.currentFilter.panel;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  get aggregate() {
    return this.AggregateDataService.aggregate;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get isLoading() {
    return this.AggregateDataService.loading;
  }

  selectAll() {
    if (!this.aggregate || !this.aggregate.cells) {
      return;
    }
    let drill = this.filterBar.drilldown[0];
    let cells = this.AggregateDataService.aggregate.cells;
    cells.forEach(cell => {
      let filter = this.model.getCellFilter(drill, cell);
      this.filter.toggleFilter(filter);
    });
    this.currentFilter.rebuildVisibleDimensions();
    this.RouterService.filterChanged();
  }

  searchAggregate(event) {
    if (event && event.keyCode !== 13) {
      return false;
    }
    this.RouterService.lookup(this.currentFilter.filterBar.lookup);
  }

  aggregate_more() {
    if (!this.filter || !this.filterBar) {
      return;
    }
    return this.AggregateDataService.aggregate_more(false);
  }

  toggleSkipStat() {
    this.currentFilter.filterBar.toggleSkipStat();
    return this.AggregateDataService.init(false);
  }

  toggleAutoUpdate() {
    this.CurrentFilterDataService.autoUpdate = !this.CurrentFilterDataService.autoUpdate;
    if (this.CurrentFilterDataService.autoUpdate) {
      this.$scope.$root.$broadcast('reload');
    }
  }
}

export const FilterDimensionComponent = {
  template  : require('./filter-dimension.component.html'),
  controller: FilterDimensionController,
};



// WEBPACK FOOTER //
// ./src/filter/filter-dimension.component.js